<!-- 
 * @description: 登录模块
 * @fileName: template.vue 
 * @author: 赖雪婷 
 * @date: 2022-04-18 17:05:28
!-->
<template>
  <div :class="this.$Base.checkSysteam() == 'MOBILE' ? 'mlogin': 'login'">
    <!-- input -->
    <div class="inputBox">
      <div class="input-style">
        <input
          type="text"
          placeholder="請輸入郵箱地址或帳號"
          class="user"
          v-model.trim="username"
          @click="focusEnd('username')"
          id="username"
        >
      </div>
      <div class="input-style">
        <input
          type="password"
          placeholder="請輸入密碼"
          class="pass"
          v-model.trim="password"
          @click="focusEnd('password')"
          id="password"
        >
      </div>
      <div
        class="input-style"
        v-if="isCodeShow"
      >
        <input
          type="text"
          placeholder="請輸入驗證碼"
          class="code"
          v-model.trim="code"
          @click="focusEnd('code')"
          id="code"
        >
        <div
          class="random"
          @click="getImage"
        >
          <img :src="imgC">
        </div>
      </div>
    </div>
    <!-- 登陆按钮 -->
    <div
      class="sendBtn"
      :class="username&&password && (isCodeShow == false || (isCodeShow && code)) ?'active':''"
      @click="login()"
    >登錄</div>
    <!-- 找回密码按钮 -->
    <div class="forgotPass">
      <span @click="childForgot">找回密碼</span>
    </div>
    <!-- or 横线 -->
    <div class="Or"></div>
    <!-- 第三方登陆 -->
    <ul class="thirdPart" v-if="system === 'PC'">
      <li
        class="google"
        @click="webDotChildLogin('click_pcldy_google')"
      >
        <google-login
          class="GoogleLogin"
          :params="GoogleParams"
          :onSuccess="GoogleonSuccess"
          :onFailure="GoogleonFailure"
        ></google-login>
      </li>
      <li
        class="facebook"
        @click="webDotChildLogin('click_pcldy_facebook')"
      >
        <fb-signin-button
          class="facebookLogin"
          :params="fbSignInParams"
          @success="FacebookonSuccess"
          @error="FacebookonFailure"
        ></fb-signin-button>
      </li>
    </ul>
    <ul class="thirdPart" v-if="system === 'MOBILE'">
      <li class="google"
        @click="webDotChildLogin('click_moldy_google')">
        <google-login
          class="GoogleLogin"
          :params="GoogleParams"
          :onSuccess="GoogleonSuccess"
          :onFailure="GoogleonFailure"
        ></google-login>
      </li>
      <li
        class="facebook"
        @click="webDotChildLogin('click_moldy_facebook')"
      >
        <fb-signin-button
          class="facebookLogin"
          :params="fbSignInParams"
          @success="FacebookonSuccess"
          @error="FacebookonFailure"
        ></fb-signin-button>
      </li>
    </ul>
  </div>
</template>

<script>
import Vue from "vue";
import FBSignInButton from "vue-facebook-signin-button";
Vue.use(FBSignInButton);
import GoogleLogin from "vue-google-login";
import { RSSign } from "../../utils/sign.js";

export default {
  name: "RastarLogin",
  props: ["appId", "pId", "mdId", "ukey", "isForgot", "someprops", "initialization", "system"],
  components: {
    GoogleLogin,
  },
  data() {
    return {
      isaa: false,
      isA: false,
      //账号
      username: "",
      // 密码
      password: "",
      // 二维码
      code: "",
      imgC: "",
      isCodeShow: false,
      token: "",
      captchaCode: "",
      GoogleParams: {
        client_id:
          "556298971641-77r57f9psi17utpcu4j67kcg15so5d0i.apps.googleusercontent.com",
      },
      fbSignInParams: {
        scope: "email,user_likes",
        return_scopes: true,
      },
      emailBindShow: 0,
      apiUrl: JSON.parse(this.$Storage.localStorageGet("api")),
    };
  },
  watch: {
    initialization: {
      handler(val, oldV) {
        console.log('initialization', val, oldV)
        if (val) {
          this.getImage();
        }
      },
      deep: true
    }
  },
  methods: {
    focusEnd (id) {
      let inpEl = document.getElementById(id)
      inpEl.focus()
      let length = inpEl.value.length
      if (document.selection) {
        let range = inpEl.createTextRange()
        range.moveStart('character', length)
        range.collapse()
        range.select()
      } else if (typeof inpEl.selectionStart === 'number' && typeof inpEl.selectionEnd === 'number') { // selectionStart和selectionEnd两个属性是当前选中文本起始位置的索引
        inpEl.selectionStart = inpEl.selectionEnd = length
      }
    },
    /*
     *@description: 触发埋点上报
     *@author: 赖雪婷
     *@date: 2022-04-18 17:06:16
     */
    webDotChildLogin(nodeVal) {
      this.$Report.webDotFather(this.pId, this.appId, this.ukey, nodeVal);
    },
    /*
     *@description: 接口错误上报
     *@author: 赖雪婷
     *@date: 2022-04-18 17:06:40
     */
    webErrorlogChild(errorMsg, action) {
      this.$Report.webErrorlogFather(
        this.pId,
        this.appId,
        this.ukey,
        errorMsg,
        action
      );
    },
    /*
     *@description: 找回密码
     *@author: 赖雪婷
     *@date: 2022-04-18 17:07:03
     */
    childForgot() {
      if (this.system === 'PC') {
        this.webDotChildLogin("click_pcldy_forget");
      } else {
        this.webDotChildLogin("click_moldy_forget");
      }
      this.$emit("forgot", true);
    },
    /*
     *@description: 获取图形验证码
     *@author: 赖雪婷
     *@date: 2022-04-18 17:07:33
     */
    getImage() {
      let _this = this;
      this.$generalMethod.captcha(this.pId, this.appId, "login").then((res) => {
        if (res.code == 200) {
          let data = res.data;
          _this.isCodeShow = data.flag == 1 ? true : false;
          _this.imgC = res.data.captcha;
          _this.captchaCode = data.captcha_code;
        } else {
          _this.$toast(res.msg.replace(/\[.*?\]/g, ""));
        }
      });
    },
    /*
     *@description: 登录前置判断
     *@author: 赖雪婷
     *@date: 2022-04-18 17:08:53
     */
    login() {
      let _this = this;
      if (
        !(
          _this.username &&
          _this.password &&
          (_this.isCodeShow == false || (_this.isCodeShow && _this.code))
        )
      )
        return;
      if (this.system === 'PC') {
        _this.webDotChildLogin("click_pcldy_password_login");
      } else {
        _this.webDotChildLogin("click_moldy_password_login");
      }
      var reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
      if (reg.test(_this.password)) {
        _this.$toast("密碼不能包含空格或者中文字符！");
        return;
      }
      //Email正则
      var ePattern =
        /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,5}$/;
      // 验证码是否一致
      if (_this.isCodeShow == 1) {
        if (_this.captchaCode.toLowerCase() != _this.code.toLowerCase()) {
          _this.$toast("驗證碼錯誤");
          return;
        }
      }
      let isCache = this.$Storage.localStorageGet("deviceIdUa");
      if (!isCache) {
        // 不存在就强制刷新页面 deviceIdUa isCache不存在
        location.reload();
      } else {
        // deviceIdUa 存在
        this.$generalMethod.freezetoken(this.pId, this.appId, this.mdId).then((res) => {
            if (res.code == 200) {
              if (ePattern.test(_this.username)) {
                let uinfoData = {
                  bind_v: _this.username,
                  bind_type: 4,
                  pwd: _this.password,
                };
                _this.loginSubmit(res.data, "Email", uinfoData);
              } else {
                let uinfoData = {
                  uname: _this.username,
                  pwd: _this.password,
                };
                _this.loginSubmit(res.data, "Account", uinfoData);
              }
            }
          });
      }
    },
    /*
     *@description: 请求登录接口
     *@author: 赖雪婷
     *@date: 2022-04-18 17:10:00
     */
    loginSubmit(token, ltype, uinfoData) {
      let _this = this;
      let data = {
        ts: new Date().getTime(),
        cch_id: _this.pId,
        app_id: _this.appId,
        md_id: _this.mdId,
        ltype: ltype,
        version: "1.0",
        type: 1,
        token: token,
        time_zone: this.$Base.timeZone(),
        nonce: this.$Base.nonce(12),
        sdk_ver: this.$Base.sdkVer(),
      };
      data.device_id = this.$Storage.localStorageGet("deviceIdUa");
      data.uinfo = this.$Ciphertext.AESkey(uinfoData);
      data.sign = RSSign(data, data.app_id);
      this.$SyModel.login(this.apiUrl.user.normal_login, data)
        .then((res) => {
          if (res.code == 200) {
            _this.emailBindShow = res.data.email_bind_show;
            this.$Storage.localStorageSet("show", _this.emailBindShow);
            this.$Storage.localStorageSet("apiUname", _this.username);
            this.$Storage.localStorageSet("apiPwd", _this.password);
            this.$Storage.localStorageSet("_XH_U_WEBSDK", res.data.uinfo);
            this.$Storage.localStorageSet("serviceUinfo", res.data.kf_uinfo);
            // 登陆成功埋点
            if (this.system === 'PC') {
              _this.webDotChildLogin("login_pcldy_password_success");
            } else {
              _this.webDotChildLogin("login_moldy_password_success");
            }
            // 登陆成功了跳转页面
            window.location.href = `/web?ukey=${_this.ukey}&appid=${_this.appId}&pid=${_this.pId}&md_id=${_this.mdId}`;
          } else {
            let errorMsg = res.msg.replace(/\[.*?\]/g, "");
            _this.$toast(errorMsg);
            _this.getImage();
          }
        })
        .catch((err) => {
          this.$toast(err.replace(/\[.*?\]/g, ""));
          this.webErrorlogChild(err.msg, "账号login接口");
        });
    },
    /*
     *@description: 谷歌登录 https://www.npmjs.com/package/vue-google-login https://developers.google.com/identity/sign-in/web/reference#auth_setup
     *@author: 赖雪婷
     *@date: 2022-04-18 17:10:24
     */
    GoogleonSuccess(googleUser) {
      let _this = this;
      this.$generalMethod.freezetoken(this.pId, this.appId, this.mdId).then((res) => {
        if (res.code == 200) {
          var googleToken = googleUser.getAuthResponse();
          var uesr = googleToken.id_token;
          let uinfoData = {
            bind_v: uesr,
            bind_type: 2,
          };
          let data = {
            ts: new Date().getTime(),
            cch_id: _this.pId,
            app_id: _this.appId,
            md_id: _this.mdId,
            ltype: "GooglePlay",
            version: "1.0",
            type: 1,
            token: res.data,
            time_zone: this.$Base.timeZone(),
            nonce: this.$Base.nonce(12),
            sdk_ver: this.$Base.sdkVer(),
          };
          data.device_id = this.$Storage.localStorageGet("deviceIdUa");
          data.uinfo = this.$Ciphertext.AESkey(uinfoData);
          data.sign = RSSign(data, data.app_id);
          this.$SyModel.login(this.apiUrl.user.normal_login, data)
            .then((res) => {
              if (res.code == 200) {
                _this.emailBindShow = res.data.email_bind_show;
                this.$Storage.localStorageSet("show", _this.emailBindShow);
                this.$Storage.localStorageSet("_XH_U_WEBSDK", res.data.uinfo);
                this.$Storage.localStorageSet("serviceUinfo", res.data.kf_uinfo);
                if (res.data.user_login_type == 1) {
                  // 1- 登录  2 - 注册
                  // 登陆成功埋点
                  if (this.system === 'PC') {
                    _this.webDotChildLogin("login_pcldy_google_success");
                  } else {
                    _this.webDotChildLogin("login_moldy_google_success");
                  }
                } else {
                  if (this.system === 'PC') {
                    _this.webDotChildLogin("signup_pcldy_google_success");
                  } else {
                    _this.webDotChildLogin("signup_moldy_google_success");
                  }
                }
                // 登陆成功了跳转页面
                window.location.href = `/web?ukey=${_this.ukey}&appid=${_this.appId}&pid=${_this.pId}&md_id=${_this.mdId}`;
              }
            })
            .catch((err) => {
              this.webErrorlogChild(err.msg, "第三方谷歌login接口");
            });
        }
      });
    },
    GoogleonFailure(error) {
      console.log("GoogleonFailure", error);
    },
    /*
     *@description: FB登录 https://blog.csdn.net/qq_42386231/article/details/120063148?utm_medium=distribute.pc_relevant.none-task-blog-2~default~baidujs_title~default-1.highlightwordscore&spm=1001.2101.3001.4242.2
     *@author: 赖雪婷
     *@date: 2022-04-18 17:10:40
     */
    FacebookonSuccess(response) {
      let _this = this;
      // 登录成功回调
      this.$generalMethod.freezetoken(this.pId, this.appId, this.mdId).then((res) => {
        if (res.code == 200) {
          var uesr = response.authResponse.accessToken;
          let uinfoData = {
            bind_v: uesr,
            bind_type: 3,
          };
          let data = {
            ts: new Date().getTime(),
            cch_id: _this.pId,
            app_id: _this.appId,
            md_id: _this.mdId,
            ltype: "FaceBook",
            version: "1.0",
            type: 1,
            token: res.data,
            time_zone: this.$Base.timeZone(),
            nonce: this.$Base.nonce(12),
            sdk_ver: this.$Base.sdkVer(),
          };
          data.device_id = this.$Storage.localStorageGet("deviceIdUa");
          data.uinfo = this.$Ciphertext.AESkey(uinfoData);
          data.sign = RSSign(data, data.app_id);
          if (response.status == "connected") {
            this.$SyModel.login(this.apiUrl.user.normal_login, data)
              .then((res) => {
                if (res.code == 200) {
                  _this.emailBindShow = res.data.email_bind_show;
                  this.$Storage.localStorageSet("show", _this.emailBindShow);
                  this.$Storage.localStorageSet("_XH_U_WEBSDK", res.data.uinfo);
                  this.$Storage.localStorageSet("serviceUinfo", res.data.kf_uinfo);
                  if (res.data.user_login_type == 1) {
                    // 1- 登录  2 - 注册
                    // 登陆成功埋点
                    if (this.system === 'PC') {
                      _this.webDotChildLogin("login_pcldy_facebook_success");
                    } else {
                      _this.webDotChildLogin("login_moldy_facebook_success");
                    }
                  } else {
                    if (this.system === 'PC') {
                      _this.webDotChildLogin("signup_pcldy_facebook_success");
                    } else {
                      _this.webDotChildLogin("signup_moldy_facebook_success");
                    }
                  }
                  // 登陆成功了跳转页面
                  window.location.href = `/web?ukey=${_this.ukey}&appid=${_this.appId}&pid=${_this.pId}&md_id=${_this.mdId}`;
                }
              })
              .catch((err) => {
                this.webErrorlogChild(err.msg, "第三方Facebook login接口");
              });
          }
        }
      });
    },
    FacebookonFailure(error) {
      console.log("FacebookonFailure====", error);
    },
  },
  created() {
    this.getImage();
  },
};
</script>

<style lang="scss" src="./style.scss" scoped></style>
